import {
  NidInquiryStatusType,
  ModalContentType
} from "../enums/index";
class Constants {
  searchPagesLength = 50;
  searchPagingLimit = 5;
  serverErrorMsg = "سرور دچار مشکل شده است،چند دقیقه دیگر امتحان کنید";
  serverErrorAuth =
    "مدت زمان اعتبار ورود شما تمام شده است،از پنل خارج شوید و دوباره وارد شوید";
  serverErrorAuthExpire =
    "مدت زمان اعتبار ورود شما تمام شده است، دوباره وارد شوید";
  authAcceptNotPossible = "به دلیل نبود هیچ تاریخچه استعلامی این کار ممکن نیست";
  DevEnvironmentText = "Use BaseDebugUrl?! ";
  DevEnvironmentTextLabelAgree = "Sure ";
  DevEnvironmentTextLabelNotAgree = "Nah ";
  AuthErrorContain = "SyntaxError";
  InternalErrorContain = "TypeError";
  EmailCannotBeEmpty = "ایمیل نمی‌تواند خالی باشد";
  PasswordCannotBeEmpty = "رمز عبور نمی‌تواند خالی باشد";
  EmailIsNotCorrect = "ایمیل درست وارد نشده است";
  SearchDropDownItemsText(type) {
    let result = "";
    if (type.includes(NidInquiryStatusType.All())) result = "همه";
    if (
      type.includes(NidInquiryStatusType.ReadyForInquiry()) ||
      type.includes(NidInquiryStatusType.InProgress())
    )
      result = "در انتظار احراز هویت";

    if (type.includes(NidInquiryStatusType.Accepted()))
      result = "احراز هویت شده";
    if (type.includes(NidInquiryStatusType.Rejected()))
      result = "احراز هویت رد شده";
    return result;
  }
  SearchDropDownItems = [
    "همه",
    "احراز هویت شده",
    "در انتظار احراز هویت",
    "احراز هویت رد شده",
  ];
  CurrentPeriodArray = [
    "شروع دوره",
    "دقیقه استفاده شده",
    "دقیقه مازاد",
    "پایان دوره",
    "دقیقه باقی مانده",
    "هزینه استفاده مازاد",
  ];
  Currency = "تومان";
  YouCannotDoInquire =
    "این کار به دلیل خالی بودن نام یا نام‌خانوادگی یا نام پدر یا تاریخ تولد ممکن نیست!!";
  AuthHistoryArray = {
    check: "بررسی",
    reason: "دلیل",
    inquire: "استعلام",
    nonsense: "نامعلوم",
    accept: "تایید شده",
    reject: "رد شده",
    open: "(",
    close: ") ",
    from: "از",
    hundred: "100",
    comma: "،",
    column: ":",
    space: " ",
    and: "و",
    with: "با",
    name: "نام",
    family: "نام‌خانوادگی",
    fathersName: "نام پدر",
    nationalCode: "کدملی",
    birthDate: "تاریخ تولد",
    error:
      "استعلام : یافت نشد (کد ملی یا تاریخ‌ تولد اشتباه است یا حروف انگلیسی وارد شده است)",
    similarity: "انطباق",
  };
  IsAlive = "زنده";
  TheyAreAlive = "مشترک در قید حیات است";
  TheyAreDead = "مشترک در قید حیات نیست";
  NoNationalCodeError = "  مشترک کد ملی ندارد پس استعلام امکان پذیر نیست";
  CopyRightReserved = "All Right Reserved";
  CopyRightLink = "DaftareShoma.com";
  On = "روشن";
  Off = "خاموش";
  Free = "رایگان";
  ActivatedBy = "فعال شده توسط";
  CurrentService = [
    "عنوان بسته",
    "وضعیت",
    "مدت",
    "شروع سرویس",
    "پایان سرویس",
    "اپراتور بسته"
  ];
  UnderLine = "_";
  Dash = "-";
  NoteIsEmpty = "متن یادداشت نمی‌تواند خالی باشد";
  RejectIdentity = "رد هویت مشترک";
  RejectActivationLabel = "عدم فعال‌سازی خط";
  RejectActivatedText = "عدم فعال‌سازی خط توسط";
  Because = "به دلیل";
  RejectActivationToastText = "عدم فعال‌سازی خط مشترک توسط شما انجام شد";
  UserHasNoServicePartOne = "مشترک تاکنون سرویس";
  UserHasNoServicePartTwo = "دریافت نکرده است!";
  Credit = "اعتبار حساب";
  NoRecord = "رکوردی برای نمایش وجود ندارد";
  ExtendService = "تمدید سرویس";
  ExtendDurationDays = [
    "۷ روز",
    "۱۴ روز",
    "۲۱ روز",
    "۳۰ روز",
    "۶۰ روز",
    "۹۰ روز",
  ];
  Extend = "تمدید";
  ExtendedSuccess = "سرویس مشترک با موفقیت تمدید شد";
  Active = "فعال";
  InActive = "غیر فعال";
  City = "شهر";
  State = "استان";
  ResidenceAddress = "خیابان اصلی"
  Street = "خیابان فرعی"
  HouseNumber = "پلاک"
  PostalCode = "کد پستی";
  CouponCreatedSuccessFully = "کد تخفیف با موفقیت ایجاد شد.";
  ChangeInfo="اطلاعات با موفقیت ویرایش شد."
  ChangeAddressSuccess = "تغییر ادرس کاربر، توسط ادمین با موفقیت انجام شد"
  ChangeInfoFailed="ویرایش اطلاعات توسط ادمین با مشکل سیستمی مواجه شد"
  ChangeAddressFailed = " تغییر آدرس توسط ادمین با مشکل سیستمی مواجه شد"
  ChangeGanderSuccess = "تغییر جنسیت کاربر، توسط ادمین با موفقیت انجام شد"
  ChangeAddressAndGenderSuccess = "تغییر ادرس و جنسیت کاربر، توسط ادمین با موفقیت انجام شد"
  UnlockChangingMobileSuccess = "امکان تغییر موبایل برای کاربر توسط ادمین با موفقیت فعال شد."

  ChangeAddressFailed = " تغییر آدرس توسط ادمین با مشکل سیستمی مواجه شد"
  ChangeGanderFailed = " تغییر جنسیت توسط ادمین با مشکل سیستمی مواجه شد"
  ChangeAddressAndGenderFailed = " تغییر آدرس و جنسیت توسط ادمین با مشکل سیستمی مواجه شد"

  CouponDisabledSuccessFully = "کد تخفیف با موفقیت غیرفعال شد.";
  CouponEnabledSuccessFully = "کد تخفیف با موفقیت فعال شد.";
  CouponExtendedSuccessFully = "کد تخفیف با موفقیت تمدید شد.";
  CouponModalTitle(type) {
    let result = "";
    if (type === ModalContentType.ExtendCoupon()) result = "تمدید اعتبار زمانی";
    if (type === ModalContentType.DisableCoupon()) result = "غیرفعال‌سازی کد";
    if (type === ModalContentType.EnableCoupon()) result = "فعال‌سازی مجدد کد";
    return result;
  }
  Infinite = "نامحدود";
  CancelFreePackage = "لغو سرویس آزمایشی";
  CancelPackage = "لغو سرویس";
  Service = "سرویس";
  ConfirmServiceCancellation = "تایید لغو سرویس";
  FreeIvrPackage = "سرویس \"تلفن گویا ۱۵ روز آزمایشی\"";
  FreeSecretaryPackage = "سرویس \"منشی مجازی ۱۵ روز آزمایشی\"";
  FreePackageCancel = "لغو سرویس";
  ChangeAddress = "تغییر آدرس توسط ادمین"
  PackageCancelledSuccess = "سرویس مشترک با موفقیت لغو شد";
  ReTestFreePackage = "تست مجدد سرویس آزمایشی";
  ReTestFreePackageSuccess = "امکان فعالسازی مجدد سرویس آزمایشی در اختیار مشترک قرار گرفت.";
  PendingToAccept = "در انتظار تایید";
  Accepted = "تایید شده‌ها";
  AcceptedFactor = "صادر شده"
  Rejected = "رد شده‌ها";
  RejectPend = "رد شده";
  Reserved = "رزرو شده‌ها"
  ReservedFactor = "رزرو شده"
  Deleted = "رد کردن"
  ReturnedFromSale = "برگشت از خرید"
  Currency = "تومان"
  ViewReson = "مشاهده دلیل"
  Reject = "رد کردن"
  SwapRowErrorUp = "امکان جابه جایی این سطر با سطر بالاتر، وجود ندارد"
  SwapRowErrorDonw = "امکان جا‌به جایی این سطر با سطر پایین‌تر وجو ندارد"
  RejectInvoiceReason = "دلیل رد فاکتور"
  ReservedInvoiceReason = "دلیل رزرو فاکتور"
  CheckedAgain = "بررسی مجدد"
  Approve = "تایید کردن"
  IsApproveCount = " را تایید می‌کنید؟"
  Rejected="فاکتور رد شده "
  Reserveed="فاکتور رزرو شده"
  Approved="فاکتور تایید شده "
  IsApprove = "آیا"
  ApproveDelete = "تایید رد فاکتور"
  NoChecked = "بررسی نشده"
  By = "توسط"
  InvoiceSaleServiceOrGoods = " صورت‌حساب فروش کالا و خدمات"
  SerialNumber = "شماره سریال"
  Date = "تاریخ"
  DaftareShomaCompany = " شرکت عزم داده پردازان  (دفتر شما)"
  PERSON_NAME_LBL = "نام شخص حقیقی/حقوقی"
  NUMBER_ECONOMI_LBL = "شماره اقتصادی"
  NATIONAL_CODE_LBL = "شناسه‌ی ملی"
  POSTAL_CODE_LBL = "کد پستی"
  PHONE_LBL = "شماره تلفن"
  FAX_LBL = "شماره فکس"
  DaftareShmaEconomicNumber = "411115873877"
  DaftareshomaTel = "411115873877"
  DaftareShomaRegisterCode = "224398"
  DaftareShmanatioNalCode = '10102656120'
  DaftareShomaPostalCode = "1955753193"
  DaftareShomaPhone = "02128420"
  DaftareshomaFax = "28420211"
  DaftareShomaAddress = "تهران - بلوار ارتش -جنب بانك پاسارگاد -پلاک ۱۱۳- طبقه چهارم واحد غربی"
  PROVINCE_ADDRESS_LBL = "نشانی کامل استان"
  CITY_LBL = "شهر"
  GOODS_INFO = "مشخصات کالا یا خدمات مورد معامله"
  ROW_NUMBER = "ردیف"
  GOODS_CODED = "کد کالا"
  EXPLAIN_GOODS = "شرح کالا/ خدمت"
  COUNT_OR_AMOUNT = "تعداد/ مقدار"
  UNIT = "واحداندازه‌گیری"
  PRICE_UNIT = "مبلغ واحد"
  DISCOUNT_PRICE = "مبلغ تخفیف"
  ADD_PRICE = "مبلغ اضافات"
  TOTAL_PRICE_AFTER_DSCOUNT_ADD = "مبلغ کل پس از تخیف و اضافات"
  SUM_TAX = "جمع مالیات و عوارض"
  TOTAL_PRICE = "مبلغ کل"
  SELER_INFO = "مشخصات فروشنده"
  BUYER_INFO = "مشخصات خریدار"
  ADRESS_LBL = "آدرس"
  Downloadpdf = "دانلود PDF"
  Back = "بازگشت"
  DownloadCSV = "دریافت خروجی CSV"
  NewReserve = "رزرو فاکتور جدید"
  EconomicCode = "کد اقتصادی"
  MobileNumber = "	شماره موبایل"
  DatePAyment = "	تاریخ پرداخت"
  NationalCode = "	کد ملی/شناسه ملی"
  PostalCode = " 	کد پستی"
  Address = "آدرس"
  City = "شهر"
  Date = "تاریخ"
  FactorNumber = "	شماره فاکتور"
  Personality = "	حقیقی/حقوقی"
  CompanyName = "	نام/نام شرکت"
  Family = "نام خانوادگی"
  DescriotionFactor = "شرح فاکتور"
  SayPrice = "مبلغ فروش"
  DiscountPrice = "مبلغ تخفیف"
  RealPrice = "	فروش خالص"
  Tax = "مالیات"
  Toll = "عوارض"
  Totall = "جمع کل"
  ReservedNewFactor = "رزرو فاکتور جدید"
  EmptyModal = "وارد کردن دلیل رزرو الزامی است"
  Description = "توضیحات"
  SignBuyer = "مهر و امضای خریدار"
  SignSeller = "مهر و امضای فروشنده"
  MethodSell = "شرایط و نحوه‌ی فروش"
  NetInvoice = "خالص فاکتور"
  Number = "عدد"
  Approve = "تایید فاکتور"
  SellApprove = "تایید فاکتور فروش"
  RecheckReason = "بررسی مجدد فاکتورهای رد شده"
  SelectMinRow = "حداقل یک سطر انتخاب کنید"
  ApproveReserved = "تایید رزرو فاکتور"
  ServerError = "در انجام عملیات سرور با مشکل مواجه شد"
  InsertSuccesfull = "تغییرات در لیست فاکتورها  با موفقیت ثبت شد"
  UpdateSuccesfull = "تغییر وضعیت فاکتور با موفقیت انجام شد"
  Nodata = "اطلاعاتی وجود ندارد"
  UnseenData = "شما اطلاعات را از تاریخ "
  Unseen = "ندیده‌اید، لطفا این تاریخ را به عنوان تاریخ شروع معتبر وارد کنید"
  NotGoodFinancialYear = " سال مالی به درستی انتخاب نشده است"
  NotExistFinancialYear = "سال مالی انتخاب شده وجود ندارد"
  NoExitDataTitle = " دربازه‌ی زمانی انتخاب شده، نوع فاکتور انتخاب شده، وجود ندارد"
  ChangeGender = "تغییر جنسیت توسط ادمین"
  ChangeBirthDate="تغییر تاریخ تولد توسط ادمین"
  ChangeFatherName="تغییر نام پدر توسط ادمین"
  ChangeLastName="تغییر نام خانوادگی توسط ادمین"
  ChangeFirstName="تغییر نام توسط ادمین"
  LastFactor = "آخرین فاکتور صادر شده"
  LastFactorDate = "تاریخ آخرین فاکتور صادر شده"
  TotalFactorListAmount = "جمع کل موارد جدول زیر "
  TotalPrice = "جمع کل"
  InDate = "در تاریخ"
  SomeChangeNotSave = "برخی تغییرات ذخیره نشده است لطفا ابتدا دکمه ی تایید کردن را بزنید"
  REGISTER_CODE_LBL = "شماره ثبت/شماره ملی"
  FirstNameAndLastName = "مشترک"
  Email = "ایمیل"
  PayableAmount = "مبلغ"
  GatewayName = "درگاه"
  PersianIssueDate = "تاریخ تراکنش"
  OfficialFactorType = "وضعیت فاکتور"
  InvoiceNumberInFactor = "شماره فاکتور"
  InvoiceAccepted = "تایید شده"
  InvoiceRejected = "رد شده"
  InvoiceReserved = "رزرو شده"
  InvoicePendingToAccept = "در انتظاار تایید"
  ReferenceNumber="شماره مالیاتی"
  MoadianStatus="وضعیت مودیان"
  ReturnAndRevok="ابطال و برگشتی"
  Revoke="ابطال شده"
  Return="برگشت شده"
  Send="ارسال شد"
  Request="درخواست کیهان توسط"
  In=" در تاریخ"

}
export default new Constants();
